import { render, staticRenderFns } from "./UploadData.vue?vue&type=template&id=5cd4c32e&"
import script from "./UploadData.vue?vue&type=script&lang=js&"
export * from "./UploadData.vue?vue&type=script&lang=js&"
import style0 from "./UploadData.vue?vue&type=style&index=0&id=5cd4c32e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports